var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#FDDFD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.996 14.8334H19.0035M12.3327 17.3334V24.4167M15.666 17.3334V24.4167M22.3327 17.3334V24.4167M25.666 17.3334V24.4167M10.666 16.1417C10.666 15.1442 11.0677 14.5334 11.8993 14.0701L15.3243 12.1642C17.1185 11.1667 18.016 10.6667 18.9993 10.6667C19.9827 10.6667 20.8802 11.1667 22.6743 12.1642L26.0993 14.0701C26.9302 14.5334 27.3327 15.1442 27.3327 16.1417C27.3327 16.4117 27.3327 16.5476 27.3035 16.6584C27.1485 17.2417 26.6193 17.3342 26.1085 17.3342H11.8902C11.3793 17.3342 10.851 17.2426 10.6952 16.6584C10.666 16.5467 10.666 16.4117 10.666 16.1417ZM24.8327 24.4167H13.166C12.503 24.4167 11.8671 24.6801 11.3982 25.149C10.9294 25.6178 10.666 26.2537 10.666 26.9167C10.666 27.0273 10.7099 27.1332 10.7881 27.2114C10.8662 27.2895 10.9722 27.3334 11.0827 27.3334H26.916C27.0265 27.3334 27.1325 27.2895 27.2106 27.2114C27.2888 27.1332 27.3327 27.0273 27.3327 26.9167C27.3327 26.2537 27.0693 25.6178 26.6004 25.149C26.1316 24.6801 25.4957 24.4167 24.8327 24.4167Z",
    stroke: "#E1732A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetailIcon);
export default __webpack_public_path__ + "static/media/BankDetailIcon.62ac879c64fad11375da998c9d14e29f.svg";
export { ForwardRef as ReactComponent };